@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in" class="flex flex-col">
      <div class="w-full mb-2">
        <div class="leading-6 font-medium">{{ field.label | localize }}</div>
        @if (field.hint) {
          <div class="text-md text-secondary">{{ field.hint | localize }}</div>
        }
      </div>
      <div class="flex flex-col xl:flex-row w-full">
        @if (field.withMap) {
          <div class="border-2 border-solid border-black mb-4 z-0 w-full xl:w-1/2">
            <div class="h-120" [id]="mapId"></div>
          </div>
        }
        <div class="basis-full xl:basis-1/2 xl:ml-4">
          @if (address) {
            <fuse-card class="flex flex-col px-8 py-6 pb-4 mb-4 bg-primary text-on-primary" #fuseCard>
              <div class="text-xl">{{ address['newName']}}</div>
              <div class="text-md">{{ address.vicinity }}</div>
            </fuse-card>
          }
          <!-- Dejamos editar las direcciones -->
          <!-- <p *ngIf="!isUpdate" class="text-lg font-semibold text-primary">{{ 'editAddress' | transloco }}</p>
          <p *ngIf="isUpdate" class="text-lg font-semibold text-primary">{{ 'editAddressName' | transloco }}</p> -->
          <p class="text-lg font-semibold text-primary">{{ 'editAddress' | transloco }}</p>
          @if (field.canEditName) {
            <mat-form-field class="w-full mt-4" appearance="fill">
              <mat-label>{{ 'name' | transloco }}</mat-label>
              <input matInput maxlength="240" [placeholder]="'name' | transloco" [formControl]="nameFormControl"
                autocomplete="off" />
              </mat-form-field>
            }
            <!-- <p *ngIf="!isUpdate" class="text-lg font-semibold text-primary my-2">{{ 'searchAddress' | transloco }}</p> -->
            <p class="text-lg font-semibold text-primary my-2">{{ 'searchAddress' | transloco }}</p>
            @if (field.canSearchWithLocation || field.canSearchWithPlaceId) {
              <mat-form-field
                class="w-1/3 xl:w-1/2 my-2">
                <mat-select [(ngModel)]="typeSelect">
                  <mat-option value="address">
                    {{ 'searchWithAddress' | transloco }}
                  </mat-option>
                  @if (field.canSearchWithLocation) {
                    <mat-option value="location">
                      {{ 'searchWithLocation' | transloco }}
                    </mat-option>
                  }
                  @if (field.canSearchWithPlaceId) {
                    <mat-option value="placeid">
                      {{ 'searchWithPlaceId' | transloco }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
            <!-- <ng-container [ngSwitch]="typeSelect" *ngIf="!isUpdate"> -->
            @switch (typeSelect) {
              @case ('address') {
                <form [formGroup]="formWithAddress" class="flex items-center basis-full mt-2"
                  (ngSubmit)="searchWithAddress()">
                  <mat-form-field [ngClass]="{'basis-4/5': !isUpdate, 'w-full': isUpdate}" appearance="fill">
                    <mat-label>{{ 'address' | transloco }}</mat-label>
                    <input matInput maxlength="1024" placeholder="Ej. Sol, Madrid" formControlName="address"
                      autocomplete="off" />
                    </mat-form-field>
                    <!-- <button *ngIf="!isUpdate" mat-raised-button type="submit" class="ml-4" color="primary"> -->
                    <button mat-raised-button type="submit" class="ml-4" color="primary">
                      {{ 'search' | transloco }}
                    </button>
                  </form>
                  @if (!address?.placeId && address?.latitude === 0 && address?.longitude === 0) {
                    <div>
                      *{{ 'addressWithouthGeolocation' | transloco }}
                    </div>
                  }
                  <!--
                  <mat-slide-toggle color="primary" [(ngModel)]="ignoreCache" class="flex flex-auto w-full">
                    {{ 'ignoreAddressSearchCache' | transloco }}
                  </mat-slide-toggle>
                  -->
                }
                @case ('location') {
                  <form [formGroup]="formWithLocation" class="flex items-center basis-full mt-2"
                    (ngSubmit)="searchWithLocation()">
                    <mat-form-field class="basis-2/5" appearance="fill">
                      <mat-label>{{ 'latitude' | transloco }}</mat-label>
                      <input matInput [placeholder]="'latitude' | transloco" formControlName="latitude"
                        autocomplete="off" />
                      </mat-form-field>
                      <mat-form-field class="basis-2/5 ml-4" appearance="fill">
                        <mat-label>{{ 'longitude' | transloco }}</mat-label>
                        <input matInput [placeholder]="'longitude' | transloco" formControlName="longitude"
                          autocomplete="off" />
                        </mat-form-field>
                        <button mat-raised-button type="submit" class="ml-4" color="primary">
                          {{ 'search' | transloco }}
                        </button>
                      </form>
                      @if (!address?.placeId && address?.latitude === 0 && address?.longitude === 0) {
                        <div>
                          *{{ 'addressWithouthGeolocation' | transloco }}
                        </div>
                      }
                      <!--
                      <mat-slide-toggle color="primary" [(ngModel)]="ignoreCache" class="flex flex-auto w-full">
                        {{ 'ignoreAddressSearchCache' | transloco }}
                      </mat-slide-toggle>
                      -->
                    }
                    @case ('placeid') {
                      <form [formGroup]="formWithPlaceId" class="flex items-center basis-full mt-2"
                        (ngSubmit)="searchWithPlaceId()">
                        <mat-form-field class="basis-4/5" appearance="fill">
                          <mat-label>PlaceId</mat-label>
                          <input matInput placeholder="PlaceId" formControlName="placeId" autocomplete="off" />
                        </mat-form-field>
                        <button mat-raised-button type="submit" class="ml-4" color="primary">
                          {{ 'search' | transloco }}
                        </button>
                      </form>
                      @if (!address?.placeId && address?.latitude === 0 && address?.longitude === 0) {
                        <div>
                          *{{ 'addressWithouthGeolocation' | transloco }}
                        </div>
                      }
                    }
                  }
                </div>
              </div>
            </div>
          }
        } @else {
          <div class="flex items-center">
            @if (!address?.placeId && address?.latitude === 0 && address?.longitude === 0) {
              <mat-icon class="mr-1" [svgIcon]="'mat_outline:error_outline'" [ngStyle]="{'color':'orange'}" matTooltip="{{'addressWithouthGeolocation' | transloco}}"></mat-icon>
            }
            {{ address.name }} - {{ address.vicinity }}
          </div>
        }
